import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/kumbhalpur.jpg";
import Newsletter from "../../shared/Newsletter";

const Kumbhalpur = () => {
  return (
    <>
      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">
          Kumbhalpur
        </h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Kumbhalgarh Wildlife Sanctuary</li>
                      <li>Kumbhalgarh Fort</li>
                      <li>Jantar Mantar</li>
                      <li>City Palace</li>
                      <li>Nahargarh Fort</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Kumbhalpur
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    In the heart of Rajputana, in the Rajsamand district of
                    Rajasthan, lies its most breathtaking fort-Kumbhalgarh.
                    Surrounded by deep ravines and deeper forests, this remote
                    and commanding citadel (which has been stormed but once) is
                    the birthplace of Rana pratap. It was built in the 15th
                    century by Rana Kumbha of Mewar. Sprawling among a cluster
                    of 13 mountain peaks, the only access is through the fort's
                    seven gates and ramparts, each lying within the other. Badal
                    Mahal and the chamber near Nimboo Pool, the last gate, are
                    steeped in historical drama. The unbroken perimeter wall
                    runs to a length of 36km, bested, it is claimed, only by the
                    Great Wall china. There are several Jain temples inside the
                    fort. Kumbhalgarh Fort is 84km from Udaipur. You can stay at
                    luxurious Aodhi Hotel, not far from the citadel.
                  </p>
                  <p>
                    The fort provided refuge to the rulers of Mewar in the times
                    of conflict, especially Udai, the baby king of Mewar. It is
                    also the birthplace of Maharana Pratap, a legendary King of
                    Mewar. The fort was made in such a way to protect it against
                    the enemy forces. Encircling the fort is a 36 km long wall,
                    with width thick enough to accommodate eight horses abreast.
                    A self-sufficient fort, Kumbhalgarh was built with almost
                    everything within its premises, with a view to endure a long
                    siege. A number of palaces as well as temples inside the
                    fort add to its appeal. Only once in its lifetime, the fort
                    fell to the combined Mughal and Amber armies, that to
                    because of a scarcity of drinking water.
                  </p>

                  <p>
                    Apart from this magnificent fort, Kumbhalgarh travel and
                    tourism is known for a number of other attractions also. The
                    Kumbhalgarh wildlife sanctuary is the perfect place for the
                    nature lovers. It is home to some of the exotic species of
                    animals as well as birds. Then there is the Muchchal Mahavir
                    temple, dedicated to Lord Mahavira and Haldighati, the venue
                    of a famous historical battle. One thing is for sure, that
                    you will not be disappointed with a visit to this fortress
                    city.
                  </p>
                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left", color: "#ee6e6e" }}
                  >
                    Places to Visit in Kumbhalgarh
                  </h2>
                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Kumbhalgarh Wildlife Sanctuary
                  </h2>

                  <p>
                    Spread over an area of 578 sq km, the Kumbhalgarh wildlife
                    sanctuary is home to a wide variety of wildlife. Wolf,
                    leopards, sloth bear, hyena, jackal, jungle cat, nilgai,
                    four horned antelope, chinkara, grey jungle fowl and a
                    number of other animals inhabit this sanctuary. A birds
                    watcher's paradise, the sanctuary serves as a habitat of
                    peacocks, doves, red spur owls, parakeets, golden oriole,
                    gray pigeons, bulbul, white breasted kingfisher, etc.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Kumbhalgarh Fort
                  </h2>
                  <p>
                    Rana Kumbha got the Kumbhalgarh fort constructed in the 15th
                    century. One of the few forts in Rajasthan that have
                    remained unconquered. Kumbhalgarh was also the birthplace of
                    Maharana Pratap, Mewar's legendary king. The attractions of
                    the fort include a number of fascinating palaces and an
                    array of temples inside it. The fort is enclosed by a thick
                    wall, running up to 36 km and offers a splendid view of the
                    surroundings.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left", color: "#ee6e6e" }}
                  >
                    Places to Stay in Kumbhalgarh
                  </h2>
                  <p>
                    The RTDC has done a lot to retain the traditional flavour in
                    its hotels in and around Kumbhalgarh. Hotels like RTDC's
                    Khadim, come with AC Deluxe rooms as well as ordinary rooms,
                    which give a comfortable stay in the city. There are also
                    Sarai facilities for the pilgrims. The government sponsored
                    paying guest scheme makes the visitor feel at home.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    How to Get there
                  </h2>
                  <p>
                    Air: Udaipur is the nearest airport from Kumbhalgarh, which
                    is serviced by regular flights to and from cities like
                    Delhi, Mumbai and Jaipur. <br/> Rail: The nearest Railhead from
                    Kumbhalgarh is Udaipur. The railway network links Udaipur to
                    Delhi, Mumbai, Jaipur and other cities of India. <br/> Road:
                    Kumbhalgarh is well connected to Udaipur, which in turn is
                    linked to other major cities in Rajasthan, Gujarat and other
                    neighboring states.
                  </p>

                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Kumbhalpur;
